import { post, postForm, del, DownloadFile, get } from "../libs/https";
const publicPath = process.env.BASE_URL;

// Documents ----------------------------------------------------------------
export const uploadDocument = async (event, id, path) => {
  const files = event.target.files;
  const formData = new FormData();
  path = path === "/" ? "" : path + "/";
  formData.append(path + files[0].name, files[0]);
  return await postForm(
    `${publicPath}api/documents/${id}/document`,
    formData,
    "none"
  );
};

export const getAllDocuments = async (path, id) => {
  return await post(`${publicPath}api/documents/${id}/all`, { path });
};

export const removeFile = async (path, id) => {
  return await del(`${publicPath}api/documents/${id}/document`, { path });
};

export const removeFolder = async (path, id) => {
  return await del(`${publicPath}api/documents/${id}/folder`, { path });
};

export const newDocumentFolder = async (path, id) => {
  return await post(`${publicPath}api/documents/${id}/folder`, { path });
};

export const download = async (file, id) => {
  let blob = await DownloadFile('PUT', `${publicPath}api/documents/${id}/document`, {
    path: file.path,
    filename: file.name,
  });
  if (blob) {
    InitiateBrowserDownload(blob, file.name);
  } else {
    return blob.message;
  }
  return;
};

export const downloadAllFiles = async (id) => {
  let blob = await DownloadFile('GET', `${publicPath}api/documents/${id}/all`);
  if (blob) {
    InitiateBrowserDownload(blob, 'documents.zip');
  } else {
    return blob.message;
  }
  return;
};

/**
 * Initiates a browser download depending on userAgent
 * @param bytes - byte array of data to be convert to a blob and downloaded by the browser
 * @param filename - name of file browser will apply to download
 * @error - function to call with error object so calling function can control response to user.
 */
const InitiateBrowserDownload = (file, filename) => {
  try {
    const userAgent = (
      navigator.userAgent ||
      navigator.vendor ||
      window.opera
    ).toLowerCase();
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        const reader = new FileReader();
        reader.onload = function() {
            window.location.href = reader.result;
        };
        reader.readAsDataURL(file);   
      } else {
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = url;
        link.download = filename;
        link.click();
        document.body.removeChild(link);
      }
  } catch (err) {
    console.error(err);
  }
};

export const getAllDocSections = async () => {
  return await get(`${publicPath}api/documents/sections`);
};
